import React from "react";
import { useSignal } from "@preact/signals-react";
import style from "./Text.module.scss";
import { TextP } from "../TextP/TextP";
import { TextH } from "../TextH/TextH";
var TEXT_H_TYPES = ["t2", "textTitle"];
var TEXT_P_TYPES = ["t1", "t2"];
export var Text = function Text(props) {
  var expanded = useSignal(false);
  return /*#__PURE__*/React.createElement("div", {
    className: style.textBox
  }, TEXT_H_TYPES.includes(props.item.type) && /*#__PURE__*/React.createElement(TextH, {
    head: props.item.head,
    expanded: expanded.value
  }), TEXT_P_TYPES.includes(props.item.type) && /*#__PURE__*/React.createElement(TextP, {
    readonlyStyle: props.readonlyStyle,
    paragraph: props.item.paragraph,
    expanded: expanded
  }));
};